import React from "react";
import LoadingGif from "../Images/trifecta-loading.gif";
import { myUtilities } from "../Utils";
class LoadingScreen extends React.Component {
  render() {
    return (
      <div className="centered-container">
        <div>
          <img src={LoadingGif} />
          <div className="loading-text">
            {myUtilities.accountSpecificLanguage("Loading", "Loading")}
          </div>
        </div>
      </div>
    );
  }
}

export default LoadingScreen;
